var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { FormField } from "../form-field";
import { Select } from "../select";
export var SelectField = React.forwardRef(function (_a, ref) {
    var autoFocus = _a.autoFocus, children = _a.children, defaultValue = _a.defaultValue, margin = _a.margin, multiple = _a.multiple, name = _a.name, native = _a.native, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, options = _a.options, placeholder = _a.placeholder, prefix = _a.prefix, onClear = _a.onClear, SelectProps = _a.SelectProps, size = _a.size, useCustomMenu = _a.useCustomMenu, value = _a.value, formFieldProps = __rest(_a, ["autoFocus", "children", "defaultValue", "margin", "multiple", "name", "native", "onBlur", "onChange", "onFocus", "onKeyDown", "onKeyUp", "options", "placeholder", "prefix", "onClear", "SelectProps", "size", "useCustomMenu", "value"]);
    return (React.createElement(FormField, __assign({ margin: margin, ref: ref }, formFieldProps),
        React.createElement(Select, __assign({ autoFocus: autoFocus, defaultValue: defaultValue, margin: margin, multiple: multiple, name: name, native: native, onBlur: onBlur, onChange: onChange, onClear: onClear, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, options: options, placeholder: placeholder, prefix: prefix, size: size, useCustomMenu: useCustomMenu, value: value }, SelectProps), children)));
});
